import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AuthToken } from 'src/api/authentication-api/model/auth-token';
import { config } from 'src/config/config';

export const FETCH_TOKEN_FIXED_CACHE_KEY = 'fetch-token';

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.AUTH_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set('Authorization', `Basic ${window.btoa(config.AUTH_CLIENT_ID + ':')}`);
    },
  }),
  keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
  endpoints: (build) => ({
    fetchToken: build.mutation<AuthToken, URLSearchParams>({
      query: (body) => ({
        url: '/am/oauth2/access_token',
        method: 'POST',
        body,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
    }),
  }),
});

export const useFetchTokenMutation = () =>
  authenticationApi.useFetchTokenMutation({
    fixedCacheKey: FETCH_TOKEN_FIXED_CACHE_KEY,
  });
